import React, { useEffect, useState } from 'react'
import { useMutation } from '@apollo/client'
import EDIT_PATIENT_REFERENCE_ID from '@dentolize/clinic-mobile/src/shared/store/mutations/actions/editPatientReferenceId'
import { Button, InputNumber, message, Modal } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import { showAuthError } from '../../../../../../shared/utils/webHelpers'
import { useTranslation } from 'react-i18next'
import { useLoginModal } from '../../../../../../context/loginModalContext'
import * as PropTypes from 'prop-types'

const EditReferenceIdButton = ({ patient, setFieldsValue }) => {
  const [open, setOpen] = useState(false)
  const [referenceId, setReferenceId] = useState(0)

  const { setLoginModalVisible } = useLoginModal()
  const { t } = useTranslation()

  const [editId, { loading }] = useMutation(EDIT_PATIENT_REFERENCE_ID)

  useEffect(() => {
    setReferenceId(patient.referenceId)
  }, [open])

  const toggleModal = () => setOpen(open => !open)

  const handleSubmit = async () => {
    try {
      if (!referenceId) {
        message.error(t('app.fieldRequired'))
        return
      }
      await editId({ variables: { patient: patient.id, referenceId } })
      message.success(t('common.updatedSuccessfully'))
      if (setFieldsValue) {
        setFieldsValue({ referenceId })
      }
      toggleModal()
    } catch (e) {
      if (e.message.includes('Patient Already Exists')) {
        message.error(t('patients.idExists'))
      } else {
        showAuthError(e, t, setLoginModalVisible)
      }
    }
  }

  return (
    <>
      <Button type="link" size="small" data-testid="patientForm-customId-open" icon={<EditOutlined />} onClick={toggleModal} />
      <Modal
        onCancel={toggleModal}
        open={open}
        title={t('app.editPatientId')}
        onOk={handleSubmit}
        confirmLoading={loading}
        okButtonProps={{ loading, 'data-testid': 'patientForm-customId-confirm' }}
      >
        <InputNumber
          min={1}
          step={1}
          onPressEnter={handleSubmit}
          precision={0}
          className="full-width"
          value={referenceId}
          onChange={setReferenceId}
          data-testid="patientForm-customId"
        />
      </Modal>
    </>
  )
}

EditReferenceIdButton.propTypes = {
  patient: PropTypes.object.isRequired,
  setFieldsValue: PropTypes.func
}

export default EditReferenceIdButton
